var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCancelUnit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_19112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4803 14.6487H10.0747C9.23278 14.6492 8.42549 14.9839 7.83016 15.5792C7.23482 16.1745 6.90014 16.9818 6.89962 17.8238V75.0815C6.90014 75.9234 7.23482 76.7307 7.83016 77.326C8.42549 77.9213 9.23278 78.256 10.0747 78.2565H72.4803C73.3223 78.2561 74.1296 77.9215 74.725 77.3261C75.3204 76.7308 75.6552 75.9234 75.6557 75.0815V17.8238C75.6552 16.9818 75.3204 16.1744 74.725 15.5791C74.1296 14.9838 73.3223 14.6491 72.4803 14.6487Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3721 58.3599H14.1836C12.4302 58.3599 11.0085 56.9382 11.0085 55.1848V4.59464C11.0085 2.84119 12.4302 1.41956 14.1836 1.41956H68.3721C70.1256 1.41956 71.5472 2.84119 71.5472 4.59464V55.1848C71.5472 56.9382 70.1256 58.3599 68.3721 58.3599Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0138 56.1897V5.59988C12.0138 3.84644 13.4354 2.4248 15.1888 2.4248H69.3774C69.9967 2.4248 70.5725 2.6048 71.0607 2.91136C70.4993 2.01628 69.5066 1.41956 68.3721 1.41956H14.1836C12.4302 1.41956 11.0085 2.84119 11.0085 4.59464V55.1848C11.0085 56.3196 11.6052 57.312 12.5003 57.8737C12.1938 57.3851 12.0138 56.8094 12.0138 56.19V56.1897Z",
    fill: "url(#paint0_linear_160_19112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7048 12.1084H20.8513V14.4366H61.7048V12.1084ZM61.7048 20.9982H20.8513V23.3264H61.7048V20.9982ZM61.7048 29.89H20.8513V32.2182H61.7048V29.89ZM61.7048 38.7799H20.8513V41.1084H61.7048V38.7799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7197 31.2651L35.9856 41.5314H25.7197V31.2651Z",
    fill: "url(#paint1_linear_160_19112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6559 42.3782V18.7575L71.5473 14.6487V42.3779H75.6559V42.3782Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4682 44.5147L76.0416 75.8498C75.8203 77.4164 74.4797 78.5806 72.8977 78.5806H9.6577C8.07574 78.5806 6.73508 77.4164 6.51377 75.8498L0.531802 33.5085C0.261966 31.597 1.74525 29.8892 3.67574 29.8892H23.2056C24.7875 29.8892 26.1282 31.0534 26.3495 32.6197L27.1334 38.1646C27.3548 39.7311 28.6954 40.8954 30.2774 40.8954H77.3249C79.2548 40.8954 80.7384 42.6033 80.4685 44.5147H80.4682Z",
    fill: "url(#paint2_linear_160_19112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7844 64.6039H17.7716C17.5139 64.6038 17.2651 64.5097 17.0718 64.3394C16.8785 64.169 16.7539 63.9339 16.7214 63.6783L16.1332 59.0213C16.1145 58.8723 16.1278 58.721 16.172 58.5775C16.2162 58.4341 16.2904 58.3016 16.3897 58.189C16.4891 58.0764 16.6112 57.9862 16.748 57.9244C16.8848 57.8625 17.0333 57.8305 17.1834 57.8304H65.3726C65.5227 57.8305 65.6711 57.8625 65.808 57.9244C65.9448 57.9862 66.0669 58.0764 66.1662 58.189C66.2655 58.3016 66.3398 58.4341 66.384 58.5775C66.4282 58.721 66.4414 58.8723 66.4227 59.0213L65.8345 63.6783C65.8021 63.9339 65.6775 64.169 65.4842 64.3394C65.2909 64.5097 65.0421 64.6038 64.7844 64.6039Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_19112",
    x1: 43.1397,
    y1: 31.7481,
    x2: 2.98557,
    y2: -8.40635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_19112",
    x1: 32.5023,
    y1: 43.1786,
    x2: 20.0935,
    y2: 30.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_19112",
    x1: 40.5,
    y1: 29.8892,
    x2: 40.5,
    y2: 78.5806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_19112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCancelUnit);
export default __webpack_public_path__ + "static/media/EmptyCancelUnit.86afcb5cb22d8727af582ac6d17857e8.svg";
export { ForwardRef as ReactComponent };